import { useCallback, useState } from 'react';
import useApi from './useApi';
import { ChangeSet } from '../types/ChangeSetTypes';
import { useAppSettings } from '../hooks/useAppSettings';
import { ChangeSetStatusEnum } from '../enums/ChangeSetStatusEnum';

export default () => {
    const { settings: appSettings } = useAppSettings();
    const { postApiData } = useApi();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const reviewChangeSet = useCallback(
        async (changeSet: ChangeSet) => {
            try {
                setLoading(true);
                setError(null);
                setSuccess(false);

                const apiUrl = appSettings?.api;
                if (!apiUrl) {
                    throw new Error('API URL not configured in app settings');
                }

                const fullUrl = `${apiUrl}/ChangeSet`;

                // Create the payload - send the full ChangeSet object with ReviewStatus set to Reviewed
                // Use PascalCase to match C# model
                const payload = {
                    Id: changeSet.id,
                    UserName: changeSet.userName,
                    DateTimeUtc: changeSet.date.toISOString(),
                    NewValues: changeSet.newValues,
                    OldValues: changeSet.oldValues,
                    TargetOfChange: changeSet.category,
                    ReviewerName: changeSet.reviewerName,
                    ReviewDateTimeUtc: changeSet.reviewDate?.toISOString() || null,
                    ReviewStatus: ChangeSetStatusEnum.Reviewed,
                    DisplayInformation: changeSet.displayInformation,
                    Type: changeSet.type,
                };

                console.log('[useReviewChangeSet] Calling:', fullUrl, 'with payload:', payload);

                const response = await postApiData({
                    endpoint: fullUrl,
                    data: payload,
                });

                console.log('[useReviewChangeSet] Success:', response);
                setSuccess(true);
                setLoading(false);
                return response;
            } catch (err: any) {
                console.error('[useReviewChangeSet] Failed to review change set:', err);
                const errorMessage = err.response?.data?.message || err.message || 'Failed to confirm review';
                setError(errorMessage);
                setLoading(false);
                throw err;
            }
        },
        [appSettings, postApiData]
    );

    const resetState = useCallback(() => {
        setError(null);
        setSuccess(false);
    }, []);

    return {
        reviewChangeSet,
        loading,
        error,
        success,
        resetState,
    };
};
